// extracted by mini-css-extract-plugin
export default {"icon":"InstallWalletModal_icon__3JBEM","button":"InstallWalletModal_button__SLyQy","header":"InstallWalletModal_header__ANFDH"};